import moment, { Moment } from 'moment-timezone';
import { LegFiJwtService } from 'app/services/auth/legfi-jwt.service';
import { User } from 'app/models/entities/user';
import { Vendor } from 'app/models/entities/vendors/vendor';

export class VendorDocument
{
    id: number;

    name: string;
    type: string;
    url: string;
    filename: string;
    filesize: number;

    userId: number;
    vendorId: number;

    user: User;
    vendor: Vendor;

    createdAt: Moment;
    updatedAt: Moment;
    deletedAt: Moment;

    hidden: boolean = false;
    rename: boolean = false;

    constructor(vendorDocument: any) {
        if (vendorDocument.id) {
            this.id = vendorDocument.id;
        }
        if (vendorDocument.name) {
            this.name = vendorDocument.name;
        }
        if (vendorDocument.type) {
            this.type = vendorDocument.type;
        }
        if (vendorDocument.url) {
            this.url = vendorDocument.url;
        }
        if (vendorDocument.filename) {
            this.filename = vendorDocument.filename;
        }
        if (!vendorDocument.name) {
            this.name = vendorDocument.filename;
        }
        if (vendorDocument.filesize) {
            this.filesize = vendorDocument.filesize;
        }
        if (vendorDocument.userId) {
            this.userId = vendorDocument.userId;
        }
        if (vendorDocument.vendorId) {
            this.vendorId = vendorDocument.vendorId;
        }

        const timezone = LegFiJwtService.getTimezone();
        if (vendorDocument.createdAt) {
            this.createdAt = moment.utc(vendorDocument.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (vendorDocument.updatedAt) {
            this.updatedAt = moment.utc(vendorDocument.updatedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (vendorDocument.deletedAt) {
            this.deletedAt = moment.utc(vendorDocument.deletedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

        if (vendorDocument.vendor) {
            this.vendor = new Vendor(vendorDocument.vendor);
        }
        if (vendorDocument.user) {
            this.user = new User(vendorDocument.user);
        }
    }
}
